
      window["APP_BUILD_INFO"] ||= {};
      window["APP_BUILD_INFO"]["contact-us"] = {"build_base_commit_hash":"456c588191b9cd93a5217989d5d5766a64453fd3","build_branch":"release_train_1186437401602","build_pub_date":"2026-07-15 19:20:09","build_version":"2.0.0.685"};
    